import _ from "lodash";
import React from "react";
import PropTypes from "prop-types";
import { isSafari } from "Utils";
import { Sentry } from "services/sentry";
import ACLStore from "lib/aclStore";

const MAX_NO_OF_CODE_SUCCESS = 7;
export default class OauthPopup extends React.PureComponent {
  constructor(props) {
    super(props);
    this.codeCheck = null;
    this.externalWindow = null;
    this.serviceType = null;
    this.numOfCodeSuccess = 0;
  }

  componentDidMount() {
    this.numOfCodeSuccess = 0;
  }

  closePopUp = () => {
    if (this.externalWindow) {
      this.externalWindow.close();
    }
    this.serviceType = null;
  };

  isPopupActive = () => {
    return (
      ACLStore.can("FeatureFlag:DisableMultiAuthWindowPopup") &&
      this.externalWindow &&
      !this.externalWindow.closed &&
      this.serviceType &&
      _.isEqual(this.serviceType, _.get(this, "props.serviceType"))
    );
  };

  createPopup = () => {
    // If a popup with the same service type is open and active, bring it into focus.
    if (this.isPopupActive()) {
      this.externalWindow.focus();
      return;
    }

    // Close any existing popup and clear the codeCheck interval before opening a new one.
    if (ACLStore.can("FeatureFlag:DisableMultiAuthWindowPopup")) {
      this.closePopUp();
      if (this.codeCheck) clearInterval(this.codeCheck);
    }

    // eslint-disable-next-line no-restricted-properties
    const windowOpen = window.open;
    const { url, title, width, height, onCode, onAccessDenied } = this.props;
    const left = window.screenX + (window.outerWidth - width) / 2;
    const top = window.screenY + (window.outerHeight - height) / 2.5;
    const isSafariOrNot = isSafari();
    this.externalWindow = windowOpen(
      url,
      "_blank",
      `width=${width},height=${height},left=${left},top=${top}`
    );
    this.serviceType = _.get(this, "props.serviceType", "");

    this.codeCheck = setInterval(() => {
      //to prevent infinite calls to onCode  (since oncode calls backend api's, which might lead to infinite calls)
      //stop after MAX_NO_OF_CODE_SUCCESS calls
      if (this.numOfCodeSuccess > MAX_NO_OF_CODE_SUCCESS) {
        clearInterval(this.codeCheck);
        this.closePopUp();
        Sentry.captureMessage("OAUTH_INFINITE_CALLS_V2", {
          extra: {
            count: this.numOfCodeSuccess,
            url: _.get(this, "props.url", ""),
            serviceType: _.get(this, "props.serviceType", ""),
            isSafariOrNot,
          },
        });
      }

      try {
        const params = new URL(_.get(this.externalWindow, "location"))
          .searchParams;

        const code = params.get("code");
        const error = params.get("error");
        if (!error && !code) {
          return;
        }
        if (
          _.isEqual(_.get(this, "props.serviceType", ""), "MICROSOFT") &&
          !_.isEmpty(error) &&
          _.isEmpty(code)
        ) {
          onAccessDenied();
        } else if (!_.isEqual(error, "access_denied")) {
          onCode(code, params);
          this.numOfCodeSuccess += 1;
        } else if (_.isEqual(error, "access_denied")) {
          onAccessDenied();
        }
        if (isSafariOrNot) {
          this.closePopUp();
        } else {
          setTimeout(() => this.closePopUp(), 350);
        }

        clearInterval(this.codeCheck);
      } catch (e) {
        //check if window is closed,
        //if closed clear interval
        if (
          this.externalWindow &&
          _.get(this.externalWindow, "closed") &&
          _.isNull(_.get(this.externalWindow, "opener"))
        ) {
          this.closePopUp();
          clearInterval(this.codeCheck);
          //to handle cases, when pop widnow is closed manually
          this.props?.onFailureCallBack?.();
        }
      }
    }, 200);

    if (this.externalWindow) {
      this.externalWindow.onpagehide = e => {
        if (isSafariOrNot && e.persisted) {
          this.props.onClose();
          clearInterval(this.codeCheck);
        }
      };
    }
    if (this.externalWindow) {
      this.externalWindow.onbeforeunload = () => {
        if (!isSafariOrNot) {
          this.props.onClose();
          clearInterval(this.codeCheck);
        }
      };
    }
  };

  render() {
    return (
      <div
        onClick={this.createPopup}
        data-test-id={`${this.props?.testId}-oAuthPopup-createPopup`}
      >
        {this.props.children}
      </div>
    );
  }

  componentWillUnmount() {
    if (this.externalWindow) {
      this.externalWindow.close();
    }

    clearInterval(this.codeCheck);
    this.numOfCodeSuccess = 0;
  }
}

OauthPopup.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  url: PropTypes.string,
  title: PropTypes.string,
  onClose: PropTypes.func,
  onCode: PropTypes.func,
  serviceType: PropTypes.string,
};

OauthPopup.defaultProps = {
  onClose: () => {},
  width: 500,
  height: 500,
  url: "",
  title: "",
  testId: "OauthPopup",
};
